import { render, staticRenderFns } from "./live-monitoring-page.vue?vue&type=template&id=c80a12f6&scoped=true"
import script from "./live-monitoring-page.vue?vue&type=script&lang=js"
export * from "./live-monitoring-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c80a12f6",
  null
  
)

export default component.exports